// features/workstations/close/live-assist.js
// Live mode — paste/type the conversation → deterministic step grading,
// the next step to run, and any objection detected. No LLM, instant.

import { useState } from 'react';

const card = { background: 'var(--surface-2)', border: '1px solid var(--border-3)', borderRadius: 12, padding: 20, marginBottom: 16 };
const inputStyle = { width: '100%', background: 'var(--surface-3)', border: '1px solid var(--border-2)', borderRadius: 8, padding: 12, color: 'inherit', fontSize: 14, fontFamily: 'inherit', minHeight: 120, resize: 'vertical' };

export default function LiveAssist() {
  const [transcript, setTranscript] = useState('');
  const [g, setG] = useState(null);
  const [busy, setBusy] = useState(false);

  const grade = async () => {
    if (!transcript.trim()) return;
    setBusy(true);
    try {
      const res = await fetch('/api/workstations/close', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'grade', transcript }),
      });
      setG(res.ok ? await res.json() : null);
    } catch { setG(null); } finally { setBusy(false); }
  };

  return (
    <div>
      <div style={card}>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Live call assist</div>
        <div style={{ fontSize: 13, color: '#9a9aa6', marginBottom: 14 }}>Paste the conversation so far — Close tells you which steps you've covered, what to do next, and flags objections.</div>
        <textarea style={inputStyle} value={transcript} onChange={(e) => setTranscript(e.target.value)} placeholder="Rep: Can I ask a couple questions first? When did you last…&#10;Prospect: …" />
        <button onClick={grade} disabled={busy || !transcript.trim()}
          style={{ marginTop: 12, padding: '10px 18px', borderRadius: 8, border: 'none', fontWeight: 600, fontSize: 14, cursor: busy ? 'not-allowed' : 'pointer', background: '#c8a96e', color: '#1a1a1a' }}>
          {busy ? 'Reading…' : 'Grade the call'}
        </button>
      </div>

      {g && g.grading && (
        <div style={card}>
          <div style={{ fontSize: 11, letterSpacing: 0.6, textTransform: 'uppercase', color: '#9a9aa6', marginBottom: 12 }}>
            Coverage — {g.grading.presentCount}/{g.grading.total} steps ({g.grading.score}%)
          </div>
          {g.next && (
            <div style={{ marginBottom: 12, fontSize: 14, color: '#c8a96e', background: 'rgba(200,169,110,.1)', border: '1px solid rgba(200,169,110,.4)', borderRadius: 8, padding: '10px 12px' }}>
              ▸ Next: <b>{g.next.label}</b>
            </div>
          )}
          {g.objection && (
            <div style={{ marginBottom: 12, fontSize: 13, color: '#d98a7e', background: 'rgba(196,96,80,.1)', border: '1px solid rgba(196,96,80,.4)', borderRadius: 8, padding: '10px 12px' }}>
              Objection detected: <b>{g.objection.label}</b> — revisit the <b>{g.objection.revisitStep}</b> step.
            </div>
          )}
          {g.grading.steps.map((s) => (
            <div key={s.key} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderTop: '1px solid var(--border-4)', fontSize: 13 }}>
              <span style={{ width: 18, height: 18, borderRadius: 5, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, background: s.present ? '#7a9e82' : 'transparent', border: `1px solid ${s.present ? '#7a9e82' : 'var(--border-2)'}`, color: '#0a0a0a' }}>{s.present ? '✓' : ''}</span>
              <span style={{ color: s.present ? 'inherit' : '#6a6a76' }}>{s.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
